import { buildLSWHPrompt, buildSubjectsPrompt } from "./aiPrompts";

const LSWH_CHAR_LIMIT = 2000;
const SUBJECTS_CHAR_LIMIT = 2000;

export const LSWH_CONFIG = {
  systemPrompt: buildLSWHPrompt(LSWH_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    responsibility: v.responsibility,
    organization: v.organization,
    independentWork: v.independentWork,
    collaboration: v.collaboration,
    initiative: v.initiative,
    selfRegulation: v.selfRegulation,
  }),
};

export const SUBJECTS_CONFIG = {
  systemPrompt: buildSubjectsPrompt(SUBJECTS_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    languagePlan: v.languagePlan,
    languageResult: v.languageResult,
    frenchPlan: v.frenchPlan,
    frenchResult: v.frenchResult,
    nativeLanguage: v.nativeLanguage,
    nativeLanguagePlan: v.nativeLanguagePlan,
    nativeLanguageResult: v.nativeLanguageResult,
    mathematicsPlan: v.mathematicsPlan,
    mathematicsResult: v.mathematicsResult,
    scienceAndTechnologyPlan: v.scienceAndTechnologyPlan,
    scienceAndTechnologyResult: v.scienceAndTechnologyResult,
    historyPlan: v.historyPlan,
    historyResult: v.historyResult,
    geographyPlan: v.geographyPlan,
    geographyResult: v.geographyResult,
    healthEducationPlan: v.healthEducationPlan,
    healthEducationResult: v.healthEducationResult,
    physicalEducationPlan: v.physicalEducationPlan,
    physicalEducationResult: v.physicalEducationResult,
    artsHeader: v.artsHeader,
    arts1: v.arts1,
    arts1Plan: v.arts1Plan,
    arts1Result: v.arts1Result,
    arts2: v.arts2,
    arts2Plan: v.arts2Plan,
    arts2Result: v.arts2Result,
    arts3: v.arts3,
    arts3Plan: v.arts3Plan,
    arts3Result: v.arts3Result,
    arts4: v.arts4,
    arts4Plan: v.arts4Plan,
    arts4Result: v.arts4Result,
    optionalStudies: v.optionalStudies,
    optionalStudiesPlan: v.optionalStudiesPlan,
    optionalStudiesResult: v.optionalStudiesResult,
  }),
};
